<div *ngIf="!listDisplay">
  <div *ngIf="!display">
    <div class="content-wrapper">
      <div>
        <div>
          <div>
            <div class="btn-wrapper">
              <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
                <span>{{'questions.typeOfQuestions.standard.btnBack' | translate}}</span>
              </button>
              <span class="spacer"></span>
              <button [disabled]="saveDisable || (addQuestionForm.invalid || addOptionNew.length < 2)" mat-flat-button
                color="" class="btn-primary" aria-label="Save" (click)='saveQuestion()'>
                <span>{{'questions.typeOfQuestions.standard.btnSave' | translate}}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="text-msg" *ngIf="saveDataValidation==true">
          <span>{{'questions.typeOfQuestions.standard.noDataMsg' | translate}}</span>
        </div>
      </div>
      <div>
        <div>
          <div>
            <div class="filter-section">
              <div class="body-section title">
                <mat-icon>library_add</mat-icon> &nbsp;
                <span>{{'questions.typeOfQuestions.standard.title' | translate}}</span>
              </div>
            </div>
            <form [formGroup]="addQuestionForm">
              <div class="editor1">
                <label class="que-label">{{'questions.typeOfQuestions.standard.labelQuest' | translate}}</label>
                <!-- <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                </ngx-editor-menu>
                <ngx-editor [editor]="editor" [placeholder]="'Enter here...'" name="questionBpx" formControlName="question"></ngx-editor> -->
                <!-- <ngx-editor [editor]="editor" name="questionBpx" [(ngModel)]="question"></ngx-editor> -->
                <!-- <ckeditor formControlName="question" data="Enter here..." [config]="ckeditorConfig" [ngClass]="{'ckeditor-loading': isCkeditorLoading}" (ready)="onCkeditorReady()"></ckeditor> -->
                <ckeditor #myEditor formControlName="question" [editor]="Editor" (ready)="onReady($event)" (click)="onClick(true)"></ckeditor>
                <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
              </div>
            </form>
            <div *ngIf="showQuestionError" class="text-msg">
              <span>{{'questions.typeOfQuestions.standard.errorQuestion' | translate}}</span>
            </div>
            <div class="filter-section">
              <div class="body-section title">
                <div class="">
                  <span>{{'questions.typeOfQuestions.standard.labelOption' | translate}}</span>
                </div>
              </div>
            </div>
            <div>
              <div class="">
                <form [formGroup]="addOptionForm">
                  <ckeditor #myEditor formControlName="option" [editor]="Editor" (ready)="onReadyOption($event)"></ckeditor>
                  <!-- <ckeditor formControlName="option" [config]="ckeditorConfig"></ckeditor> -->
                </form>
                <div *ngIf="errorMessageOption" class="alert alert-danger">{{ errorMessageOption }}</div>
              </div>
            </div>
            <div *ngIf="!addOptions" class="text-msg">
              <span>{{'questions.typeOfQuestions.standard.errorOption' | translate}}</span>
            </div>
            <div class="btn-container">
              <button mat-flat-button color="" class="btn-warn"
                (click)='addOption()'>{{'questions.typeOfQuestions.standard.btnAddOptions' | translate}}
              </button>
              <!-- <button mat-flat-button color="" class="btn-warn" (click)='addOption()' class="btn-bg-color">
                {{'questions.typeOfQuestions.standard.btnAdd' | translate}}
              </button> -->
            </div>
            <div class="" *ngIf="editMode==false">
              <div *ngIf="questionscoreF==true && scoringTypeId == ScoringTypeEnum.OnQuestion">
                <label class="Questions-score">{{'questions.typeOfQuestions.standard.labelQuestScore' |
                  translate}}</label>
                <input (keypress)="keyPressNumbers($event)" min="0" value="newEvent" [(ngModel)]="newEvent"
                  class="form-control scoreInput" readonly>

              </div>
              <div class=" " cdkDropList (cdkDropListDropped)="dragAndDrop($event)">
                <label class="mrg-top"
                  *ngIf="questionscoreF==true && scoringTypeId != ScoringTypeEnum.On180360Degree">{{'questions.typeOfQuestions.standard.labelSetScore'
                  | translate}}</label>
                <label class="mrg-top"
                  *ngIf="questionscoreF==true && scoringTypeId == ScoringTypeEnum.On180360Degree">{{'questions.typeOfQuestions.standard.labelStyle'
                  | translate}}</label>
                <div class="add-option" *ngFor="let o of addOptionNew; let i = index" cdkDrag>
                  <div class="input-class-container " *ngIf="scoringTypeId != ScoringTypeEnum.On180360Degree">
                    <mat-radio-button class="radio-btn-class" type="radio" [value]="o" id="o{{i}}" name="o"
                      (change)="onCheckRadioOption($event.value)" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                    </mat-radio-button>

                    <input type="number" class="form-control"
                    min="0" max="9999.99" step=".01"
                    value="" [(ngModel)]="o.correctPoints" (keypress)="omit_special_char($event)"
                    (change)="addScore(o)" (input)="validateInput($event, o, 'options')">

                    <!-- <input type="number" min="0" max="9999" onkeydown="if(event.key==='.'){event.preventDefault();}"
                      oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                      onkeypress="if(this.value.length == 4 ) return false;" value="" [(ngModel)]="o.correctPoints"
                      (change)="addScore(o)" class="form-control "> -->
                    <ng-component class="optionss" [innerHTML]="o?.answerDescription?.description  | sanitizeHtml">
                    </ng-component>
                    <div class="drag-box" *cdkDragPreview>
                      <span [innerHtml]="o?.answerDescription?.description"></span>
                    </div>
                  </div>

                  <div class="input-class-container " *ngIf="scoringTypeId == ScoringTypeEnum.On180360Degree">
                    <div class="row">
                      <div class="col-md-6">
                        <ng-component class="optionss" [innerHTML]="o?.answerDescription?.description | sanitizeHtml">
                        </ng-component>
                      </div>
                      <div class="col-md-6" style="width: 20%;">
                        <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid"
                          ng-reflect-model="" (change)="onSelectStyle($event, o?.optionId)">
                          <option>{{'questions.typeOfQuestions.standard.optionSelect' | translate}}</option>
                          <option *ngFor="let option of StyleList" [value]="option?.styleId">
                            {{option?.styleName}}
                          </option>
                        </select>

                        <!-- <ng-multiselect-dropdown
                          [settings]="StyleDropdownSettings"
                          [data]="StyleList"
                          (onSelect)="onSelectStyle($event, o?.answerDescription?.description)"
                          (onDeSelect)="onStyleDeSelect($event, o?.answerDescription?.description)">
                        </ng-multiselect-dropdown> -->
                      </div>
                    </div>
                    <div class="drag-box" *cdkDragPreview>
                      <span [innerHtml]="o?.answerDescription?.description"></span>
                    </div>
                  </div>
                  <div></div>
                  <div class="mat-icon-div">
                    <button mat-icon-button
                      matTooltip="{{'questions.typeOfQuestions.standard.addOptions.toolTip.edit' | translate}}"
                      (click)="openDialog(o?.answerDescription?.description, o?.optionId, i)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button
                      matTooltip="{{'questions.typeOfQuestions.standard.addOptions.toolTip.delete' | translate}}"
                      [ngClass]="{'disableIcon': roleSer.accessData? !roleSer.accessData.deleteAllowed:true}" (click)="deleteOption(i)">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                    <!-- <button mat-icon-button class="action-button" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item (click)="openDialog(o?.answerDescription?.description, o?.optionId)">
                        <mat-icon>edit</mat-icon>
                        <span>
                          {{'questions.typeOfQuestions.standard.addOptions.toolTip.edit' | translate}}
                        </span>
                      </button>
                      <button mat-menu-item [disabled]="roleSer.accessData? !roleSer.accessData.deleteAllowed:true" (click)="deleteOption(i)">
                        <mat-icon>delete_outline</mat-icon>
                        <span>
                          {{'questions.typeOfQuestions.standard.addOptions.toolTip.delete' | translate}}
                        </span>
                      </button>
                    </mat-menu> -->

                  </div>
                </div>
              </div>

            </div>
            <div class="" *ngIf="editMode==true">
              <div *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                <label class="Questions-score">{{'questions.typeOfQuestions.standard.labelQuestScore' |
                  translate}}</label>
                <input type="number" (keypress)="keyPressNumbers($event)" min="0" value="newEvent"
                  [(ngModel)]="newEvent" class="form-control scoreInput" readonly>

              </div>
              <div class="" cdkDropList (cdkDropListDropped)="drop1($event)">
                <label class="mrg-top"
                  *ngIf="questionscoreF==true && scoringTypeId != ScoringTypeEnum.On180360Degree">{{'questions.typeOfQuestions.standard.labelSetScore'
                  | translate}}</label>
                <label class="mrg-top"
                  *ngIf="questionscoreF==true && scoringTypeId == ScoringTypeEnum.On180360Degree">{{'questions.typeOfQuestions.standard.labelStyle'
                  | translate}}</label>
                <div class="add-option" *ngFor="let o of fetchEditOption; let i = index" cdkDrag>
                  <div class="input-class-container" *ngIf="scoringTypeId != ScoringTypeEnum.On180360Degree">

                    <mat-radio-button class="radio-btn-class" type="radio" [checked]="o?.answerValid==true" [value]="o"
                      id="o{{i}}" name="o" (change)="onCheckRadioOption($event.value)" required
                      *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                    </mat-radio-button>
                    <input type="number" class="form-control"
                    min="0" max="9999" step=".01" (keypress)="omit_special_char($event)"
                    value="" [(ngModel)]="o.correctPoints"
                    (change)="addScore(o)" (input)="validateInput($event, o, 'options')">


                    <!-- <input type="number" min="0" max="9999" onkeydown="if(event.key==='.'){event.preventDefault();}"
                      oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                      onkeypress="if(this.value.length == 4 ) return false;" value="" [(ngModel)]="o.correctPoints"
                      class="form-control " (change)="addScore(o)"> -->
                    <ng-component class="optionss" [innerHTML]="o?.answerDescription?.description  | sanitizeHtml">
                    </ng-component>

                    <!-- <app-preview-option-editor class="optionss" [optionValue]="o?.answerDescription?.description" [innerHtml]="o?.answerDescription?.description">
                    </app-preview-option-editor> -->
                    <div class="drag-box" *cdkDragPreview>
                      <span [innerHtml]="o?.answerDescription?.description"></span>
                    </div>
                  </div>
                  <div class="input-class-container " *ngIf="scoringTypeId == ScoringTypeEnum.On180360Degree">
                    <div class="row">
                      <div class="col-md-6">
                        <ng-component class="optionss" [innerHTML]="o?.answerDescription?.description | sanitizeHtml">
                        </ng-component>
                      </div>
                      <div class="col-md-6" style="width: 20%;">
                        <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid"
                          ng-reflect-model="" (change)="onSelectStyle(o.styleId, o?.optionId)" [(ngModel)]="o.styleid">
                          <option>select</option>
                          <option *ngFor="let option of StyleList" [value]="option?.styleId">
                            {{option?.styleName}}
                          </option>
                        </select>

                        <!-- <ng-multiselect-dropdown
                          [settings]="StyleDropdownSettings"
                          [data]="StyleList"
                          [(ngModel)]="o.selectedStyle"
                          (onSelect)="onSelectStyle($event, o?.answerDescription?.description)"
                          (onDeSelect)="onStyleDeSelect($event, o?.answerDescription?.description)">
                        </ng-multiselect-dropdown> -->
                      </div>
                    </div>
                    <div class="drag-box" *cdkDragPreview>
                      <span [innerHtml]="o?.answerDescription?.description"></span>
                    </div>
                  </div>
                  <div></div>
                  <div class="mat-icon-div">
                    <button mat-icon-button
                      matTooltip="{{'questions.typeOfQuestions.standard.addOptions.toolTip.edit' | translate}}"
                      (click)="openDialog(o?.answerDescription?.description, o?.optionId, i)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button
                      matTooltip="{{'questions.typeOfQuestions.standard.addOptions.toolTip.delete' | translate}}"
                      [ngClass]="{'disableIcon': roleSer.accessData? !roleSer.accessData.deleteAllowed:true}"
                      (click)="deleteEditOption(i,o)">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                    <!-- <button mat-icon-button class="action-button" [matMenuTriggerFor]="menu"
                      aria-label="Example icon-button with a menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item (click)="openDialog(o?.answerDescription?.description, o?.optionId)">
                        <mat-icon>edit</mat-icon>
                        <span> {{'questions.typeOfQuestions.standard.addOptions.toolTip.edit' | translate}}</span>
                      </button>
                      <button mat-menu-item [disabled]="roleSer.accessData? !roleSer.accessData.deleteAllowed:true"
                        (click)="deleteEditOption(i,o)">
                        <mat-icon>delete_outline</mat-icon>
                        <span>{{'questions.typeOfQuestions.standard.addOptions.toolTip.delete' | translate}}</span>
                      </button>
                    </mat-menu> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="exp-panel">
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{'questions.typeOfQuestions.standard.accordian.title' | translate}}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <form [formGroup]="userForm">
                    <div class="container-fluid">
                      <div class="row" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                        <div class="col-md-2">
                          <div class="scoring-check">
                            <mat-checkbox name="autoscoring" formControlName="autoscore" [checked]="autoscoring"
                              [disabled]="true"><b>{{'questions.typeOfQuestions.standard.accordian.checkbox' |
                                translate}}</b>
                            </mat-checkbox>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="scoring-check">
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-2" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                          <div class="form-label">
                            <label>{{'questions.typeOfQuestions.standard.accordian.selectOptions.option1.label' |
                              translate}}</label>
                          </div>
                        </div>
                        <div class="col-md-3" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                          <mat-form-field class="scoring-type" appearance="fill"
                            [hideRequiredMarker]="hideRequiredControl.value" [floatLabel]="floatLabelControl.value">
                            <mat-select formControlName="scoringTypeMatch" [(value)]="getscoringtype" [disabled]="true">
                              <mat-option [value]="option.id == 1 ? 'true' : 'false'"
                                *ngFor="let option of QuestionScoringType">{{option.title}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-md-2 answers-label">
                          <div class="form-label">
                            <label>{{'questions.typeOfQuestions.standard.accordian.selectOptions.option2.label' |
                              translate}}</label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <mat-form-field class="scoring-type" appearance="fill">
                            <mat-select formControlName="questionDisplay" [(value)]="getQuestionDisplay">
                              <mat-option [value]="option.title"
                                *ngFor="let option of QuestionOrientation">{{option.title}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="row " *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                        <!-- <div class="col-md-2">
                          <div class="form-label score-labels">
                            <label>{{'questions.typeOfQuestions.standard.accordian.selectOptions.option3' |
                              translate}}</label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <input min="0" [attr.disabled]="true" type="number" formControlName="penaltyPoint"
                            class="form-control penalty-points" type="number" min="0" max="9999"
                            onkeypress="if(this.value.length == 4 ) return false;">
                        </div> -->
                        <div class="col-md-2">
                          <div class="form-label score-labels">
                            <label required>{{'questions.typeOfQuestions.standard.accordian.selectOptions.option4.label'
                              | translate}}</label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <input type="number" class="form-control penalty-points"
                          min="0" step=".01"  formControlName="minimumScoreIfAttempt" (keypress)="omit_special_char($event)"
                          (input)="validateInput($event, 0, 'minimumScore')">

                          <!-- <input min="0" class="form-control penalty-points" formControlName="minimumScoreIfAttempt"
                            type="number" onkeypress="if(this.value.length == 4 ) return false;"
                            (keyup)="replace2Decimal($event, userForm.controls.minimumScoreIfAttempt)"
                            (keypress)="omit_special_char($event, o)"> -->
                          <div *ngIf=" userForm.controls.minimumScoreIfAttempt.errors"
                            class="alert alert-danger w-75 zero">
                            <div *ngIf="userForm.controls.minimumScoreIfAttempt.errors.required">
                              {{'questions.typeOfQuestions.standard.accordian.selectOptions.option4.errorMsg1' |
                              translate}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="display">
    <app-choose-question-type></app-choose-question-type>
  </div>
</div>

<div *ngIf="listDisplay">
  <app-question-list></app-question-list>
</div>
